<template>
  <div>
    <b-form-group class="mb-0" :label="`${label}:`" label-cols-md="4">
      <requiredComponent
        slot="label"
        :label="`${label}:`"
        :rules="$v.baseInput.$params"
        :showRequired="required"
      />
      <b-row align-v="center" align-h="center" class="flex-row-reverse mx-0">
        <b-col
          class="px-1 input_box"
          :class="{
            danger: $v.baseInput.$error,
            success: $v.baseInput.$dirty && !$v.baseInput.$error,
          }"
          cols="2"
          md=""
          v-for="item in numFields"
          :key="item"
        >
          <b-form-input
            v-model="$v['inputNumber' + item].$model"
            type="text"
            autocomplete="off"
            :minLength="inputDigits"
            :maxLength="inputDigits"
            class="dir_ltr px-0 pr-1 font-weight-bold"
            :class="{
              'border-danger': $v.baseInput.$error,
              'border-success': $v.baseInput.$dirty,
            }"
            :id="inputId + item"
            @input="watchInput(item)"
          />
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="
            p-2
            rounded
            mt-2
            text-right
            font-weight-bold
            fs_16
            dir_ltr
            result_box
          "
          :class="{
            'bg-danger': $v.baseInput.$error,
            'bg-success': $v.baseInput.$dirty,
          }"
          v-text="
            prefix +
            setFormat(
              inputNumber1 +
                inputNumber2 +
                inputNumber3 +
                inputNumber4 +
                inputNumber5 +
                inputNumber6
            )
          "
        />
        <b-col cols="12" md="12">
          <b-form-invalid-feedback
            :state="$v.baseInput.$dirty ? !$v.baseInput.$error : null"
          >
            <div v-if="!$v.baseInput.required">
              {{ $lang.error_required | replace(label) }}
            </div>
            <div v-if="!$v.baseInput.minLength">
              {{ $lang.error_max | replace(label, digits) }}
            </div>
            <div v-if="!$v.baseInput.maxLength">
              {{ $lang.error_max | replace(label, digits) }}
            </div>
            <div v-if="!$v.baseInput.numeric">
              {{ $lang.error_numeric | replace(label) }}
            </div>
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>
<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  validations: {
    baseInput: {
      requiredIf: requiredIf((vm) => vm.required),
      numeric,
      minLength: minLength(24),
      maxLength: maxLength(24),
    },
    inputNumber1: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
    inputNumber2: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
    inputNumber3: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
    inputNumber4: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
    inputNumber5: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
    inputNumber6: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
  },
  props: {
    label: {
      // show field label
      type: String,
      default: "",
    },
    prefix: {
      // show prefix string in result box
      type: String,
      default: "",
    },
    defaultValue: {
      // default value for edit mode
      type: String,
      default: "",
    },
    inputId: {
      // set dynamic id for inputs
      type: String,
      default: "inputId",
    },
    numInputs: {
      // number of inputs
      type: String,
      default: "6",
    },
    inputDigits: {
      // input per digits
      type: String,
      default: "4",
    },
    digits: {
      // sheba length
      type: String,
      default: "24",
    },
    getValueState: {
      // watch for check validation and emit value
      type: Boolean,
      default: false,
    },
    required: {
      // set required validation
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      baseInput: "",
      inputNumber1: "",
      inputNumber2: "",
      inputNumber3: "",
      inputNumber4: "",
      inputNumber5: "",
      inputNumber6: "",
    };
  },
  watch: {
    defaultValue(value) {
      this.setDefaultValue(value);
    },
    getValueState(value) {
      this.$v.$touch();
    },
    baseInput(value) {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$emit("updateValue", "");
        return;
      }
      this.$emit("updateValue", value);
    },
    inputNumber2(newValue, oldValue) {
      if (!newValue && oldValue) {
        const inputNumber1 = document.getElementById(this.inputId + 1);
        inputNumber1 && inputNumber1.focus();
      }
    },
    inputNumber3(newValue, oldValue) {
      if (!newValue && oldValue) {
        const inputNumber2 = document.getElementById(this.inputId + 2);
        inputNumber2 && inputNumber2.focus();
      }
    },
    inputNumber4(newValue, oldValue) {
      if (!newValue && oldValue) {
        const inputNumber3 = document.getElementById(this.inputId + 3);
        inputNumber3 && inputNumber3.focus();
      }
    },
    inputNumber5(newValue, oldValue) {
      if (!newValue && oldValue) {
        const inputNumber4 = document.getElementById(this.inputId + 4);
        inputNumber4 && inputNumber4.focus();
      }
    },
    inputNumber6(newValue, oldValue) {
      if (!newValue && oldValue) {
        const inputNumber5 = document.getElementById(this.inputId + 5);
        inputNumber5 && inputNumber5.focus();
      }
    },
  },
  computed: {
    numFields() {
      /* guidance: generate num field items array for v-for in template */
      const data = [];
      for (let i = 1; i <= this.numInputs; i++) {
        data.push(i);
      }
      return data;
    },
  },
  methods: {
    watchInput(inputItem) {
      /* guidance: watch input when change */
      const inputNumber2 = document.getElementById(this.inputId + 2);
      const inputNumber3 = document.getElementById(this.inputId + 3);
      const inputNumber4 = document.getElementById(this.inputId + 4);
      const inputNumber5 = document.getElementById(this.inputId + 5);
      const inputNumber6 = document.getElementById(this.inputId + 6);
      this.baseInput =
        this.inputNumber1 +
        this.inputNumber2 +
        this.inputNumber3 +
        this.inputNumber4 +
        this.inputNumber5 +
        this.inputNumber6;
      switch (inputItem) {
        case 1:
          if (!this.$v.inputNumber1.$error && inputNumber2) {
            inputNumber2.select();
          }
          this.$v.$touch();
          break;
        case 2:
          if (!this.$v.inputNumber2.$error && inputNumber3) {
            inputNumber3.select();
          }
          this.$v.$touch();
          break;
        case 3:
          if (!this.$v.inputNumber3.$error && inputNumber4) {
            inputNumber4.select();
          }
          this.$v.$touch();
          break;
        case 4:
          if (!this.$v.inputNumber4.$error && inputNumber5) {
            inputNumber5.select();
          }
          this.$v.$touch();
          break;
        case 5:
          if (!this.$v.inputNumber5.$error && inputNumber6) {
            inputNumber6.select();
          }
          this.$v.$touch();
          break;
        case 6:
          this.$v.$touch();
          break;
      }
    },
    setFormat(str) {
      /* guidance: set format sheba number and show in result box */
      return str ? str.match(/.{1,4}/g).join("") : "";
    },
    setDefaultValue(data) {
      if (data) {
        const dataArr = data.match(/.{1,4}/g);
        this.inputNumber1 = dataArr[0];
        this.inputNumber2 = dataArr[1];
        this.inputNumber3 = dataArr[2];
        this.inputNumber4 = dataArr[3];
        this.inputNumber5 = dataArr[4];
        this.inputNumber6 = dataArr[5];
        this.baseInput = this.defaultValue;
        this.$v.$touch();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.input_box {
  &::before {
    content: "";
    position: absolute;
    bottom: -15px;
    left: 0;
    right: 0;
    margin: auto;
    width: 2px;
    height: 15px;
    background-color: #f0f3f5;
  }
}
.input_box.danger {
  &::before {
    background-color: #f86c6b;
  }
}
.input_box.success {
  &::before {
    background-color: #4dbd74;
  }
}
.result_box {
  letter-spacing: 2px;
  background-color: #f0f3f5;
}
</style>
